import { render, staticRenderFns } from "./TreatyLimit.vue?vue&type=template&id=68785fe2&"
import script from "./TreatyLimit.vue?vue&type=script&lang=js&"
export * from "./TreatyLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports